// Ruban éditorial défilant (marquee lent)
export const Marquee = ({ items }) => {
  const content = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className="grain bg-dough border-y border-crustborder py-6 overflow-hidden select-none"
      aria-hidden="true"
    >
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {content.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-2xl sm:text-4xl text-charcoal px-6 sm:px-8">
              {item}
            </span>
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-crust shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};
